export default __webpack_public_path__ + "static/media/userAvatar.a6143582.png";